import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';
import experiment from 'experiment';

export const moveWidgetPluginAction = {
  label: 'PLATFORM_Widget_Slots_Move_Plugin_RCM_text',
  enabled: () => true,
  onClick(editorAPI: EditorAPI, widgetCompRef: CompRef) {
    editorAPI.closeRightClickMenu();

    const slotSelectionPanelName =
      'panels.widgetPanels.slotSelectionExtendedPanel';

    editorAPI.panelManager.openPanel(slotSelectionPanelName, {
      slotsPlaceholderCompRef:
        editorAPI.platform.widgetPlugins.getSlotPlaceholderRefByContentRef(
          widgetCompRef,
        ),
    });
  },
  automationId: 'widgetPluginMoveToSlot',
  condition: (editorAPI: EditorAPI, widgetCompRef: CompRef | CompRef[]) => {
    const compRef = Array.isArray(widgetCompRef)
      ? widgetCompRef[0]
      : widgetCompRef;

    const baseCondition =
      experiment.isOpen('se_widgetPlugins') &&
      editorAPI.platform.widgetPlugins.isWidgetPluginComponent(compRef);

    if (baseCondition) {
      const slotPlaceholderRef =
        editorAPI.platform.widgetPlugins.getSlotPlaceholderRefByContentRef(
          compRef,
        );

      return editorAPI.platform.widgetPlugins.isSlotContentPotentialMovable(
        slotPlaceholderRef,
      );
    }

    return baseCondition;
  },
};
